"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attributeType = exports.productState = void 0;
var productState = {
  fullyResolved: 'fullyResolved',
  partiallyResolved: 'partiallyResolved'
};
exports.productState = productState;
var attributeType = {
  listOfValues: 'listOfValues'
};
exports.attributeType = attributeType;